import styles from 'styles/components/domainName.module.scss';

const DomainName = ({ domain }) => (
  <span className={domain.name ? styles.nameVisible : styles.nameNotVisible}>
    {domain.name || 'abcdefgh.com'}
  </span>
);

export default DomainName;
